// extracted by mini-css-extract-plugin
export default {"controls":"ModalControls_controls__ETijy","counter":"ModalControls_counter__WnpHd"};